module.exports = __webpack_public_path__ + "img/maduo3.a052d014.jpg";